import React from 'react';
import { useAppConfig } from '../../context/AppConfigContext';
import { buildWhatsAppHref } from '../funnel/whatsappMessage';
import { OperationalScreen } from './OperationalScreen';

/**
 * Full-viewport screen rendered in place of the public funnel when
 * `runtime_controls.maintenance_enabled` is true. Admin routes are NOT
 * affected (App.tsx renders AdminConfiguracion before AppContent ever
 * mounts), so flipping this flag is always reversible from the admin.
 */
export const MaintenanceScreen: React.FC = () => {
  const { config, logoImage } = useAppConfig();
  const ops = config.runtime_controls;
  // Sin URL explícita caemos al WhatsApp de contact_rules: así la CTA sigue
  // funcionando sin ningún teléfono escrito en el código, y el operador puede
  // apuntarla a otro sitio rellenando la URL.
  const ctaUrl =
    (ops?.maintenance_cta_url || '').trim() || buildWhatsAppHref(config.contact_rules?.whatsapp_phone || '', '');
  const ctaLabel = (ops?.maintenance_cta_label || '').trim();
  const showCta = ctaUrl.length > 0 && ctaLabel.length > 0;

  return (
    <OperationalScreen
      logoSrc={logoImage}
      logoAlt="Milo y Lola"
      emoji="🛠️"
      title={ops?.maintenance_title || 'Estamos haciendo una mejora rápida'}
      message={ops?.maintenance_message || 'La calculadora estará disponible de nuevo en unos minutos.'}
      action={
        showCta ? (
          <a
            href={ctaUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block mt-4 px-6 py-3 rounded-xl font-fredoka text-base font-medium bg-[#008BBC] text-white hover:bg-[#007aa8] shadow-sm transition-all"
          >
            {ctaLabel}
          </a>
        ) : undefined
      }
    />
  );
};
